
const AlertClose = () => {
	return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0.5 0.498993L23.5 23.499" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M23.5 0.498993L0.5 23.499" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>);
}

export default AlertClose;
